import mediaFormats from '../../shared/mediaFormats.json';

const FFMPEG_CORE_BASE_URL = 'https://whisper-cpp-models.s3.eu-west-3.amazonaws.com';
const VIDEO_EXTENSION_PATTERN = new RegExp(`\\.(${mediaFormats.videoExtensions.join('|')})$`, 'i');

function inputExtension(file) {
  return file.name?.toLowerCase().match(/\.([a-z0-9]+)$/)?.[1] || 'video';
}

function isVideo(file) {
  return file.type?.startsWith('video/') || VIDEO_EXTENSION_PATTERN.test(file.name || '');
}

export async function prepareDatasetAudioSource(file) {
  if (!isVideo(file)) return { file, details: { sourceKind: 'audio' } };

  const [{ FFmpeg }, { fetchFile, toBlobURL }] = await Promise.all([
    import('@ffmpeg/ffmpeg'),
    import('@ffmpeg/util'),
  ]);
  const ffmpeg = new FFmpeg();
  const input = `dataset-input.${inputExtension(file)}`;
  const output = 'dataset-source.mka';

  try {
    await ffmpeg.load({
      coreURL: await toBlobURL(`${FFMPEG_CORE_BASE_URL}/ffmpeg-core.js`, 'text/javascript'),
      wasmURL: await toBlobURL(`${FFMPEG_CORE_BASE_URL}/ffmpeg-core.wasm`, 'application/wasm'),
    });
    await ffmpeg.writeFile(input, await fetchFile(file));
    await ffmpeg.exec([
      '-i', input,
      '-map', '0:a:0',
      '-c:a', 'copy',
      '-vn',
      '-map_metadata', '-1',
      output,
    ]);
    const bytes = await ffmpeg.readFile(output);
    return {
      file: new File([bytes], 'source.mka', { type: 'audio/x-matroska' }),
      details: {
        codec: 'unknown',
        container: 'mka',
        encodingQuality: 'unknown',
        sourceKind: 'video-audio-stream',
      },
    };
  } finally {
    await ffmpeg.deleteFile(input).catch(() => undefined);
    await ffmpeg.deleteFile(output).catch(() => undefined);
    ffmpeg.terminate();
  }
}
